import { NgModule } from '@angular/core';
import { FloatingLinesBackgroundComponent } from './floating-lines-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        FloatingLinesBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        FloatingLinesBackgroundComponent
    ]
})
export class NcFloatingLinesBackgroundModule { }